import React from 'react';
import { typedMemo } from '../../helpers/typedMemo';
import { OptionsType, RawValue } from './VtxSelect';
import { ValuesType as SingleValue } from 'utility-types';
import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import './VtxSelect.scss';
import { IAutomatable, preventDataAutomationOverriding } from '../../helpers/IAutomatable';
import classNames from 'classnames';
import { VtxIcon } from '../..';
import { arrowIconProp, baseSelectDataAutomationClass } from './commonSelectConcerns';

export interface VtxMultiSelectProps<
    ValueArray extends RawValue[],
    Op extends OptionsType<SingleValue<ValueArray>> = never
> extends Omit<SelectProps<ValueArray>, 'suffixIcon' | 'menuItemSelectedIcon' | 'removeIcon'>, IAutomatable {
    options?: Op;
    onChange?: VtxMultiSelectOnChange<ValueArray>;
    /**
     * @default 'multiple'
     */
    mode?: 'multiple';
}

export type VtxMultiSelectOnChange<VT extends RawValue[]> = (value: VT) => void;

export const VtxMultiSelect = typedMemo(
    <ValueArray extends RawValue[] = RawValue[], TKeyForOptions extends RawValue = string>(
        props: VtxMultiSelectProps<ValueArray, OptionsType<SingleValue<ValueArray>, TKeyForOptions>>
    ) => {
        const automationClass = 'vtx-multiple-select';
        const {
            className,
            style,
            children,
            dropdownClassName,
            ...otherProps
        } = preventDataAutomationOverriding(props);
        const classNamesCombined = classNames(
            baseSelectDataAutomationClass,
            automationClass,
            props.className
        );

        return (
            <Select
                data-automation-class={automationClass}
                className={classNamesCombined}
                dropdownClassName={
                    dropdownClassName ? (classNames(automationClass), dropdownClassName) : automationClass
                }
                menuItemSelectedIcon={<VtxIcon type="check" fontSize="20px" />}
                removeIcon={<VtxIcon type="close" fontSize={'14px'} />}
                mode="multiple"
                {...arrowIconProp}
                {...otherProps}
            >
                {children}
            </Select>
        );
    }
);
